const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls } = wp.editor;
const { PanelBody, SelectControl } = wp.components;
const { Fragment } = wp.element;
import { InnerBlocks } from '@wordpress/block-editor';

function getLink(adPlatform, fValue) {
    var link = '';
    switch (adPlatform) {
        case 'tradetracker':
            link = `https://rotator.tradetracker.net/?r=${fValue}&t=js`;
            break;
    }

    return link;
}
 

function blogOptions(domainname) {
    const currentBlogs = data['blog-block']['blogdata'][domainname];
    const blogsOptions = [{label: "--", value: ""}];

    currentBlogs.forEach((item) => {
        blogsOptions.push({label: item['title'], value: JSON.stringify({title: item['title'], slug: item['slug']})})
    });

    return blogsOptions;
}



registerBlockType('custom-widget/advertisement-banner', {
    title: 'Advertentie banner',
    icon: 'tag',
    category: 'common',

    attributes: {
        fieldValue: {
            type: 'string',
            value: ''
        },
        advertisementPlatform: {
            type: 'string',
            default: 'tradetracker'
        }
    },

    edit({ attributes, setAttributes }) {
        function updateFieldValue(newValue) {
            setAttributes({ fieldValue: newValue });
        }
        var link = '';
        if(attributes.fieldValue && attributes.fieldValue != '') {
            link = getLink(attributes.advertisementPlatform, attributes.fieldValue);
        }
        return ([
            <InspectorControls key="inspector">
                <PanelBody>
                    <p><strong>Vul hier het advertentiebannernummer in:</strong></p>
                    <input
                        value={attributes.fieldValue}
                        placeholder="Vul hier het advertentiebannernummer in"
                        onChange={(e) => updateFieldValue(e.target.value)}
                        type="number"
                    />
                    <SelectControl
                        label="Kies een advertentieplatform:"
                        value={attributes.advertisementPlatform}
                        options={[
                            { label: "Trade tracker", value: "tradetracker" }
                        ]}
                        onChange={(newValue) => setAttributes({ advertisementPlatform: newValue })}
                    />
                </PanelBody>
            </InspectorControls>,

            <div style={{ backgroundColor: "yellow", padding: "10px" }} className="advertisement_banner_section">
                <p><strong>Advertisement Banner widget</strong></p>
                <p>Verander de code in het menu aan de rechterhand</p>
                <p>{link}</p>
            </div>
        ]);
    },

    save({ attributes }) {
        var link = getLink(attributes.advertisementPlatform, attributes.fieldValue);
        return (
            <script src={ link }></script>
        );
    }
});

if(data['blog-block']['domainname']) {
    registerBlockType('custom-widget/blog-block', {
        title: 'Blog block',
        icon: 'tag',
        category: 'common',

        attributes: {
            selectedBlog: {
                type: 'string',
                default: ''
            }
        },

        edit({ attributes, setAttributes }) {
            function updateFieldValue(newValue) {
                setAttributes({ fieldValue: newValue });
            }
            console.log(attributes.fieldValue);
            return ([
                <InspectorControls key="inspector">
                    <PanelBody>
                        <SelectControl
                            label="Kies een blog:"
                            value={attributes.selectedBlog}
                            options={
                                blogOptions(data['blog-block']['domainname'])
                            }
                            onChange={(newValue) => setAttributes({ selectedBlog: newValue })}
                        />
                    </PanelBody>
                </InspectorControls>,

                <div style={{ backgroundColor: "yellow", padding: "10px" }} className="blog_section">
                    <p><strong>Blogs Banner widget</strong></p>
                    <p>Verander de code in het menu aan de rechterhand</p>
                </div>
            ]);
        },

        save({ attributes }) {
            var data = JSON.parse(attributes.selectedBlog);
            return (
                <div class="blog_post_block card col-md m-2">
                    <div class="card-body">
                        <h5 class="card-title text-wrap">{ data['title'] }</h5>
                        <a href={ data['slug'] } class="btn btn-primary">Bekijk blog</a>
                    </div>
                </div>
            );
        }
    });
}
else {
    registerBlockType('custom-widget/blog-block', {
        title: 'Blog block',
        icon: 'tag',
        category: 'common',

        attributes: {
            selectedBlog: {
                type: 'string',
                default: ''
            }
        },
        edit() {
            return (
                <div style={{ backgroundColor: "red", padding: "10px" }} className="blog_section">
                    <p><strong>Blogs Banner widget</strong></p>
                    <p><strong>Let op!</strong> Deze pagina heeft nog geen domeinnaam</p>
                    <ol>
                        <li>Voeg eerst een domeinnaam toe</li>
                        <li>Sla de pagina op</li>
                        <li>Herlaad de pagina</li>
                        <li>Nu werkt de blog widget</li>
                    </ol>
                </div>
            )
        },
        save() {

        }
    });
}

console.log(data['header-block']);
console.log(data['footer-block']);

registerBlockType('custom-widget/header', {
    title: 'Header widget',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        return (
            <header style={{ border: "1px dashed black" }} data-aos="fade-down" class="header">
                <InnerBlocks />
            </header>
            
        );
    },

    save({ attributes }) {
        return (
            <header data-aos="fade-down" className="header">
                <InnerBlocks.Content />
            </header>
            
        );
    }
});



registerBlockType('custom-widget/footer', {
    title: 'Footer widget',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        return (
            <footer style={{ border: "1px dashed black" }} data-aos="fade-down" class="footer">
                <InnerBlocks />
            </footer>
            
        );
    },

    save({ attributes }) {
        return (
            <footer data-aos="fade-down" className="footer">
                <InnerBlocks.Content />
            </footer>
            
        );
    }
});

registerBlockType('custom-widget/footer-nav-items', {
    title: 'Footer nav items widget',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        var footerData = data["footer-block"]['footer-items'];
        return (
            <ul className="pages-section nav justify-content-center pb-3 mb-3">
                {footerData.map((footerItem, index) => (
                    <li className="nav-item">
                        <a className="nav-link" href={footerItem['slug']}>{footerItem['title']}</a>
                    </li>
                ))}
            </ul>
        );
    },

    save({ attributes }) {
        var footerData = data["footer-block"]['footer-items'];
        return (
            <ul className="pages-section nav justify-content-center pb-3 mb-3">
                {'{{footer_menu_items}}'}
            </ul>
        );
    }
});

registerBlockType('custom-widget/header-nav-items', {
    title: 'Header nav items widget',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        var headerData = data["header-block"]['header-items'];
        return (
            <nav className="navbar navbar-light navbar-expand-lg p-3">
                <div className="navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        {headerData.map((headerItem, index) => (
                            <li className="nav-item">
                                <a className="nav-link" href={headerItem['slug']}>{headerItem['title']}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>

        );
    },

    save({ attributes }) {
        var headerData = data["header-block"]['header-items'];
        return (
            <nav className="navbar navbar-light navbar-expand-lg p-3">
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        {'{{header_menu_items}}'}
                    </ul>
                </div>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </nav>
        );
    }
});


registerBlockType('custom-widget/contact-form', {
    title: 'Contact formulier',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        return (
            <div style={{ backgroundColor: "yellow", padding: "10px" }} className="blog_section">
                <p><strong>Contactformulier</strong></p>
            </div>
        );
    },

    save({ attributes }) {
        var link = getLink(attributes.advertisementPlatform, attributes.fieldValue);
        return (
            <div class="container">
                <div class="col-12">
                    <form method="POST">
                        <div class="form-group">
                            <label for="company">Bedrijfsnaam:</label>
                            <input name="company" value="" type="text" class="form-control required" id="company" placeholder="Vul hier uw bedrijfsnaam in"></input>
                        </div>
                        <div class="form-group">
                            <label for="name">Naam:</label>
                            <input name="name" value="" type="text" class="form-control required" id="name" placeholder="Vul hier uw naam in"></input>
                        </div>
                        <div class="form-group">
                            <label for="street">Straat + huisnummer:</label>
                            <div class="row g-3">
                                <div class="col">
                                    <input name="street" value="" type="text" class="form-control required" id="street" placeholder="Vul hier uw straat in"></input>
                                </div>
                                <div class="col">
                                    <input name="housenumber" value="" type="number" class="form-control required" id="housenumber" placeholder="Vul hier uw huisnummer in"></input>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="postalcode">Postcode:</label>
                            <input name="postalcode" value="" type="text" class="form-control required" id="postalcode" placeholder="Vul hier uw postcode in"></input>
                        </div>
                        <div class="form-group">
                            <label for="city">Woonplaats:</label>
                            <input name="city" value="" type="text" class="form-control required" id="city" placeholder="Vul hier uw woonplaats in"></input>
                        </div>
                        <div class="form-group">
                            <label for="email">E-mailadres:</label>
                            <input name="email" value="" type="email" class="form-control required" id="email" placeholder="Vul hier je e-mailadres in"></input>
                        </div>
                        <div class="form-group">
                            <label for="phone">Telefoon:</label>
                            <input name="phone" value="" type="number" class="form-control required" id="phone" placeholder="Vul hier uw telefoonnummer in"></input>
                        </div>
                        <div class="form-group mb-2">
                            <label for="message">Bericht:</label>
                            <textarea name="message" class="form-control required" id="message" rows="3" placeholder="Schrijf hier je bericht"></textarea>
                        </div>
                        <div id="contactFormRecaptcha" class="g-recaptcha"></div>
                        <button id="submit_button" type="submit" class=" btn btn-primary">Verstuur</button>
                    </form>
                </div>
            </div>
        );
    }
});


registerBlockType('custom-widget/domains-widget', {
    title: 'Domein widget',
    icon: 'tag',
    category: 'common',

    edit({ attributes, setAttributes }) {
        return (
            <div style={{ backgroundColor: "yellow", padding: "10px" }} className="blog_section">
                <p><strong>Domeinen lijst</strong></p>
            </div>
        );
    },

    save({ attributes }) {
        var link = getLink(attributes.advertisementPlatform, attributes.fieldValue);
        data['domains-block']['domains'].map((domainName, index) => (
            console.log(domainName)
        ));
        return (
            <div className="d-flex py-5 px-1">
                <div className="container">
                    <h1 className="title">Alle beschikbare domeinnamen!</h1>
                    <p>Bekijk hier alle beschikbare domeinnamen.</p>
                    {data['domains-block']['domains'].map((domainName, index) => (
                        <div class="domain_block card col-md mb-2 m-md-2">
                        <div class="card-body">
                            <h5 class="card-title text-wrap">{domainName}</h5>
                            <a href={domainName} class="btn btn-primary">Bezoek domein!</a>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        );
    }
});

